import type { Editor } from "@tiptap/react";
import { t } from "@/i18n-js/instance";
import { MenuBarItem } from "@circle-react-shared/BuilderUI/Editor/fields/RichTextField/MenuBarItem";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useAddTipTapLinkModal } from "@circle-react-uikit/TipTapBlockEditor/AddTipTapLinkModal";
import { MenuBarVariableButton } from "./MenuBarVariableButton";

export interface VisualEmailMenuBarProps {
  editor: Editor | null;
}

export const VisualEmailMenuBar = ({ editor }: VisualEmailMenuBarProps) => {
  const tiptapLinkModal = useAddTipTapLinkModal();

  const handleLinkClick = () => {
    if (!editor) {
      return;
    }

    void tiptapLinkModal.show({ editor, isEmailEditor: true });
  };

  return (
    <div className="-mx-3 mb-2 flex items-center gap-0.5 border-b p-1.5">
      <MenuBarItem
        isActive={editor?.isActive("bold")}
        icon="16-bold"
        onClick={() => editor?.chain().focus().toggleBold().run()}
      />
      <MenuBarItem
        isActive={editor?.isActive("italic")}
        onClick={() => editor?.chain().focus().toggleItalic().run()}
        icon="16-italic"
      />
      <MenuBarItem
        isActive={editor?.isActive("underline")}
        onClick={() => editor?.chain().focus().toggleUnderline().run()}
        icon="16-edit-underline"
      />
      {/* // Editor is of type Editor | null, but the InsertVariableButtonWrapper expects an Editor | undefined */}
      <MenuBarVariableButton
        editor={editor ?? undefined}
        isActive={editor?.isActive("variables")}
      />
      <TippyV2
        placement="top"
        interactive={false}
        content={t("tiptap.add_entity")}
        dataTestId="add_entity_list"
      >
        <IconButton
          iconSize={20}
          ariaLabel={t("tiptap.add_entity")}
          name="20-tiptap-entity"
          onClick={() => {
            editor?.chain().focus().insertContent(" #").run();
          }}
        />
      </TippyV2>
      <MenuBarItem
        isActive={editor?.isActive("link")}
        icon="16-link-alt"
        onClick={handleLinkClick}
      />
    </div>
  );
};
